import { WEBUILogs } from "../logging";
import getType from "../base/typeOfOperand";

export default function (parsable, format = "YYYY-MM-DD") {
    if (!parsable) {
        //WEBUILogs.error("simpleFormat: Not supplied parsable date!");
        return;
    } else {
        let input = parsable;
        if (getType(input) === "string" && input.length === 10 && input.includes("-")) {
            //In case we supply ISO string data (which should be the only string date we work with)
            //We want to ensure that the Date will be created at 00:00:00 without respecting one's timezone!
            input += "T00:00:00";
        }
        let date = new Date(input);
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        let monthLong = month;
        if (month < 10) {
            monthLong = "0" + month;
        }
        let dayLong = day;
        if (day < 10) {
            dayLong = "0" + day;
        }
        let separator;
        switch (format) {
            case "DD/MM/YYYY":
            case "DD-MM-YYYY":
            case "DD.MM.YYYY":
                separator = format[2];
                return dayLong + separator + monthLong + separator + year;
            case "MM/DD/YYYY":
            case "MM-DD-YYYY":
            case "MM.DD.YYYY":
                separator = format[2];
                return monthLong + separator + dayLong + separator + year;
            case "YYYY/MM/DD":
            case "YYYY-MM-DD":
            case "YYYY.MM.DD":
                separator = format[4];
                return year + separator + monthLong + separator + dayLong;
            case "D/M/YYYY":
            case "D-M-YYYY":
            case "D.M.YYYY":
                separator = format[1];
                return day + separator + month + separator + year;
            case "M/D/YYYY":
            case "M-D-YYYY":
            case "M.D.YYYY":
                separator = format[1];
                return month + separator + day + separator + year;
            case "MM/YYYY":
                separator = format[2];
                return month + separator + year;
            case "YYYY":
                return year;
            default:
                WEBUILogs.error("Unrecognized format suppled to simpleFormat");
                return;
        }
    }
}
